import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch, Select } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import ERP from "../../../../../utils/ErpService";

export default function InvBodegasForm(props) {
  const { record, closeModal, currentUser, gst_users, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.bdg_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [responsable, setResponsable] = useState(record.usr_id);

  const { Option } = Select;

  useEffect(() => {
    setCurId(record.bdg_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await ERP.sendMaestro(
      currentUser,
      curId,
      "InvBodegas",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE BODEGAS O DEPOSITOS",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE BODEGAS O DEPOSITOS",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="InvBodegas"
      onFinish={guardarCambios}
      initialValues={{
        bdg_codigo: record.bdg_id > 0 ? record.bdg_codigo : "",
        bdg_nombre: record.bdg_id > 0 ? record.bdg_nombre : "",
        usr_id: record.bdg_id > 0 ? record.usr_id : "",
        bdg_area: record.bdg_id > 0 ? record.bdg_area : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.bdg_id > 0
            ? "ACTUALIZAR BODEGAS O DEPOSITOS"
            : "AGREGAR BODEGAS O DEPOSITOS"}
        </Title>
      </Form.Item>
      <Form.Item
        name="bdg_codigo"
        label="Codigo"
        rules={[
          {
            required: true,
            message: "El codigo es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase", width: "100px" }}
          value={record.bdg_id > 0 ? record.bdg_codigo : ""}
        />
      </Form.Item>
      <Form.Item
        name="bdg_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.bdg_id > 0 ? record.bdg_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="usr_id"
        label="Responsable"
        wrapperCol={{ span: 100 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
          <Select
            showSearch
            showArrow
            style={{ width: "200px" }}
            defaultValue={responsable}
            onChange={(val) => setResponsable(val)}
            placeholder="Responsable"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {gst_users.map((responsable) => (
              <Option key={responsable.id} value={responsable.id}>
                {responsable.nombre}
              </Option>
            ))}
          </Select>
      </Form.Item>
      <Form.Item
        name="bdg_area"
        label="Area M2"
        rules={[
          {
            required: true,
            message: "El area es obligatoria",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase", width: "125px" }}
          value={record.bdg_id > 0 ? record.bdg_area : ""}
        />
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
